module.exports = __webpack_public_path__ + "img/Схема регулярного расчета.0cf69573.png";